import { useDispatch, useSelector } from 'react-redux'
import EditItem from '../../../../shared/components/IconButtons/EditItem'
import CampoInputRadio from '../../../../shared/components/CampoInputComButton/CampoInputRadio/CampoInputRadio'
import { useEffect, useState } from 'react'
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice'

const CampoInputEncaminhaSeguro = ({ onClick, editButton, disabled }) => {
    const [value, setValue] = useState("")
    const { insurance } = useSelector(state => state.ocorrenciaState)
    const dispatch = useDispatch()
    
    const handleChange = (name, value) => {
        if(value === "Sim") dispatch(handleOcorrenciaChange({[name]: "1"}))
        if(value === "Não") dispatch(handleOcorrenciaChange({[name]: "0"}))
        setValue(value)
    }

    useEffect(() => {
        if(insurance === "1") setValue("Sim") 
        if(insurance === "0") setValue("Não") 
        if(insurance === "") setValue() 
        
    }, [insurance])
    
    const handleClick = (e) => {
        e.preventDefault()
        onClick("insurance")
    }

    return (
        <CampoInputRadio
            id="inputEncaminhaSeguro"
            titulo="Artigo será encaminhado para seguro?*"
            onChange={handleChange}
            name="insurance"
            value={value}
            radioValores={["Sim", "Não"]}
            required={true}
            disabled={disabled} >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputRadio>
    )
}

export default CampoInputEncaminhaSeguro
